




import { Vue, Component, Prop } from "@/shared/vuepack";
import { EmbeddedServiceBootstrap } from  "@/shared/types";
import { Config } from "@/shared/config";

declare global {
 interface Window {
    embeddedservice_bootstrap?: EmbeddedServiceBootstrap;
    __sfChatInitialized?: boolean;
  }
}

@Component
export default class SalesForceChatScript extends Vue {
    @Prop()
    firstName: string;
    @Prop()
    lastName: string;
    @Prop()
    email: string;
    @Prop()
    phone: string;
    @Prop()
    hashkey: string;
    @Prop()
    salesforceBase2Url: string;
    @Prop()
    salesforceScrt2Url: string;
    @Prop()
    salesforceBootstrapUrl: string;
    @Prop()
    salesforceOrgId: string;
    @Prop()
    chatDelay: number;
    @Prop()
    chatFunctionality: string;

    created () {
      window.addEventListener("onEmbeddedMessagingReady", this.onEmbeddedMessageReady);
    }

    async mounted () {
      await this.loadSalesforceScript();
      this.onEmbeddedMessageReady();
    }
    onEmbeddedMessageReady () {
      const prechatAPI = window.embeddedservice_bootstrap && window.embeddedservice_bootstrap?.prechatAPI;
      if (!prechatAPI) {
        return;
      }

      prechatAPI.setHiddenPrechatFields({
        Customer_First_Name: this.firstName,
        Customer_Last_Name: this.lastName,
        Customer_Email: this.email,
        Customer_Phone: this.phone,
        Chat_Hashkey: this.hashkey,
        Chat_Functionality: this.chatFunctionality,
        });
        prechatAPI.setVisiblePrechatFields({
          _subject : { value: null, isEditableByEndUser: true},
        });
    }
    beforeDestroy () {
      window.removeEventListener("onEmbeddedMessagingReady", this.onEmbeddedMessageReady);
    }
    loadSalesforceScript (): Promise<void> {
      return new Promise((resolve, reject) => {
        const src =
          this.salesforceBootstrapUrl;
        if (document.querySelector(`script[src="${src}"]`)) {
          // ensure the botton is shown
          const button = document.querySelector<HTMLElement>(".embeddedMessagingConversationButton");
          if (button) {
            button.style.display = "block";
          }
          resolve();
          return;
        }
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.id = "salesforce-chat-script";
        script.onload = () => {
          window.embeddedservice_bootstrap.settings.language = "en_US";
          window.embeddedservice_bootstrap.init(
            this.salesforceOrgId,
            "Chat_Desk_Enhanced",
            this.salesforceBase2Url,
            {
              scrt2URL: this.salesforceScrt2Url
            });
        };
        script.onerror = () => reject(new Error("Failed to load Salesforce script"));
        document.body.appendChild(script);
      });
    }
}
